/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { TabMenu } from 'primereact/tabmenu';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { SplitButton } from 'primereact/splitbutton';
import { InputSwitch } from 'primereact/inputswitch';
import { RadioButton } from 'primereact/radiobutton';

import ModalPreview from '@components/Section/ModalPreview'
import FileInput from '@components/FileInput';

import { SET_VALUES_SECTION } from '@constants/actionType';
import { LANGUAGE_DEFAULT } from '@constants/general';

import store from '@store';

class CarouselForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      languagePreview: [],
      errors: [],
      showModalPreview: {
        title: '',
        visible: false,
        children: ''
      }
    }
    // this.initialValuesForm = {
    //     title: '',
    //     cards: [],
    // }
    this.initialValuesCardForm = {
      backgroundImg: [],
      hasBnt: true,
      btnHref: '',
      btnTarget: '_blank',
      hasBntSecondary: true,
      btnHrefSecondary: '',
      btnTargetSecondary: '_blank',
    };
    this.initialValuesCardFormByLanguage = {
      title: '',
      btnText: '',
      btnTextSecondary: '',
      description: '',
    };
  }

  componentDidMount() {
    const { keysLenguages, _carousel, itemsTabsLenguages, t } = this.props;
    if (_carousel) {
      this.setState({
        ..._carousel,
      });
    } else {
      const state = {
        cards: [{ ...this.initialValuesCardForm }]
      }
      keysLenguages.map((item) => {
        state.cards[0][item] = { ...this.initialValuesCardFormByLanguage }
      })
      console.log('state', state)
      this.setState({...state})
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      const label = `${t('En')  } ${  item.label.replace(`(${t('Obligatorio')})`, '')}`
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    this.setState({ languagePreview })
    this.setState({ loadingPage: false });
  }

  onChangeCard = ({target}) => {
    const [index, language, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][language][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCardSimple = ({target}) => {
    const [index, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  uploadFileCard = (files, isImage, index) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    const newCard = this.state.cards
    newCard[index].backgroundImg = [data]
    this.setState({ cards: newCard }, () => this.validateFieldsOnchange(`${index}-backgroundImg`, data));
  };

  removeFileCard = (index) => {
    const newCard = this.state.cards
    console.log('-----', newCard[index])
    newCard[index].backgroundImg = []
    this.setState({ cards: newCard });
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { cards } = this.state
    let errors = {}
    cards.map((item, index) => {
      if (!item[LANGUAGE_DEFAULT].title) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-title`]: `${t('Titulo')} ${t('es requerido')}` }
      if (!item[LANGUAGE_DEFAULT].description || item[LANGUAGE_DEFAULT].description === '\n') errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}` }
      if (!item.backgroundImg.length) errors = { ...errors, [`${index}-backgroundImg`]: `${t('Imagen')} ${t('es requerido')}` }
      if (item.hasBnt) {
        if (!item[LANGUAGE_DEFAULT].btnText) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-btnText`]: `${t('Texto Botón')} ${t('es requerido')}`}
        if (!item.btnHref) errors = { ...errors, [`${index}-btnHref`]: `${t('Link')} ${t('es requerido')}` }
      }
      if (item.hasBntSecondary) {
        if (!item[LANGUAGE_DEFAULT].btnTextSecondary) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-btnTextSecondary`]: `${t('Texto Botón')} ${t('es requerido')}`}
        if (!item.btnHrefSecondary) errors = { ...errors, [`${index}-btnHrefSecondary`]: `${t('Link')} ${t('es requerido')}` }
      }
      return item
    })
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props
    await this.setValuesToStateGlobal()
    success();
  };

  setValuesToStateGlobal = async () =>  {
    const { cards } = this.state
    return await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: { carousel: {cards} },
    });
  }

  onPreview = async (language) => {
    // const { keysLenguages } = this.props
    // const { activeTabIndex } = this.state;
    await this.setValuesToStateGlobal()
    // const language = keysLenguages[activeTabIndex];

    return this.setState({showModalPreview: {
      visible: true,
      language,
    }})
  }

  onHideModalPreview = () => {
    this.setState({showModalPreview: { visible: false }})
  }

  template = (options, index) => {
    const { t } = this.props;
    const getCards = this.state.cards;
    const toggleIcon = options.collapsed
      ? 'pi pi-chevron-down'
      : 'pi pi-chevron-up';
    const className = `${options.className} p-jc-beetween`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <div>
          <button
            type="button"
            className={options.togglerClassName}
            onClick={options.onTogglerClick}
          >
            <span className={toggleIcon} />
            <Ripple />
          </button>
          <span className={titleClassName}>
            {t('Banner')} {index + 1} {t('de')} {getCards.length}
          </span>
        </div>
        { getCards.length !== 1 && (
          <div>
            <Button
              icon="pi pi-trash"
              type="button"
              className="p-button-text p-button-plain"
              onClick={() => this.removeService(index)}
            />
          </div>
        )}
      </div>
    );
  };

  addService = () => {
    const { keysLenguages } = this.props;
    const newCards = this.state.cards
    const stateCard =  [{ ...this.initialValuesCardForm }]
    keysLenguages.map((item) => {
      stateCard[0][item] = { ...this.initialValuesCardFormByLanguage }
    })
    newCards.push(stateCard[0])
    this.setState({ cards: newCards })
  };

  removeService = (index) => {
    const newCards = this.state.cards
    newCards.splice(index, 1)
    this.setState({ cards: newCards })
  };

  render() {
    const {
      t,
      btnSubmitLoading,
      history,
      itemsTabsLenguages,
      keysLenguages,
      onBack,
    } = this.props;
    const { activeTabIndex, loadingPage, showModalPreview, languagePreview, errors  } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderCards = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      const getCards = this.state.cards;
      return getCards.map((item, index) => (
        <div className="p-col-12" key={`card-${index}`}>
          <Panel
            headerTemplate={(e) => this.template(e, index)}
            collapsed={index >= 1}
            toggleable
          >
            <div className="p-fluid p-grid">
              <div className="p-col-12">
                {itemsTabsLenguages && (
                  <TabMenu
                    model={itemsTabsLenguages}
                    activeIndex={activeTabIndex}
                    onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                  />
                )}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                {t('Titulo', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-title`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].title}
                  onChange={this.onChangeCard}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-title`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-title`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                  {t('Texto Botón', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-btnText`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].btnText}
                  onChange={this.onChangeCard}
                  disabled={!this.state.cards[index].hasBnt}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-btnText`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-btnText`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                  {t('Texto Botón Secundario', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-btnTextSecondary`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].btnTextSecondary}
                  onChange={this.onChangeCard}
                  disabled={!this.state.cards[index].hasBntSecondary}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-btnTextSecondary`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-btnText`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="description" className="p-text-bold">
                  {t('Descripción', {lng: prefixLenguage })}
                </label>
                <Editor
                  name={`${index}-${prefixLenguage}-description`}
                  style={{ height: '200px' }}
                  value={this.state.cards[index][prefixLenguage].description}
                  onTextChange={e => this.onChangeCard({target: { name: `${index}-${prefixLenguage}-description`, value: e.textValue }})}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-description`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-description`)}
              </div>
              <div className="p-divider p-component p-divider-horizontal p-divider-dashed p-d-flex p-jc-between" role="separator">
                <div className="p-divider-content">
                  <b>{t('Opciones de Botón')}</b>
                </div>
                <div className="p-divider-content">
                  <InputSwitch
                    name={`${index}-hasBnt`}
                    checked={this.state.cards[index].hasBnt}
                    onChange={this.onChangeCardSimple}
                  />
                </div>
              </div>
              <div className="p-col-12 p-md-6 p-lg-6">
                <div className="p-field">
                  <label className="p-text-bold">{t('Link')}</label>
                  <span className="p-input-icon-left">
                    <i className="pi pi-globe" />
                    <InputText
                      name={`${index}-btnHref`}
                      value={this.state.cards[index].btnHref}
                      onChange={this.onChangeCardSimple}
                      disabled={!this.state.cards[index].hasBnt}
                      className={classNames({
                        'p-invalid': isFormFieldValid(`${index}-btnHref`),
                      })}
                    />
                  </span>
                  {getFormErrorMessage(`${index}-btnHref`)}
                </div>
              </div>
              <div className="p-col-12 p-md-6 p-lg-6">
                <label className="p-text-bold">{t('Abrir en')}</label>
                <div className="p-field-radiobutton p-mt-2">
                  <RadioButton
                    inputId={`btnTarget${index}`}
                    name={`${index}-btnTarget`}
                    value="_blank"
                    onChange={this.onChangeCardSimple}
                    checked={this.state.cards[index].btnTarget === '_blank'}
                    disabled={!this.state.cards[index].hasBnt}
                  />
                  <label className="p-pr-3" htmlFor={`btnTarget${index}`}>{t('Nueva ventana')}</label>
                  <RadioButton
                    inputId={`btnTarget${index}`}
                    name={`${index}-btnTarget`}
                    value="_self"
                    onChange={this.onChangeCardSimple}
                    checked={this.state.cards[index].btnTarget === '_self'}
                    disabled={!this.state.cards[index].hasBnt}
                  />
                  <label htmlFor={`btnTarget${index}`}>{t('Ventana actual')}</label>
                </div>
                {/* <div className="p-field-radiobutton">
                </div> */}
              </div>
              <div className="p-divider p-component p-divider-horizontal p-divider-dashed p-d-flex p-jc-between" role="separator">
                <div className="p-divider-content">
                  <b>{t('Opciones de Botón Secundario')}</b>
                </div>
                <div className="p-divider-content">
                  <InputSwitch
                    name={`${index}-hasBntSecondary`}
                    checked={this.state.cards[index].hasBntSecondary}
                    onChange={this.onChangeCardSimple}
                  />
                </div>
              </div>
              <div className="p-col-12 p-md-6 p-lg-6">
                <div className="p-field">
                  <label className="p-text-bold">{t('Link')}</label>
                  <span className="p-input-icon-left">
                    <i className="pi pi-globe" />
                    <InputText
                      name={`${index}-btnHrefSecondary`}
                      value={this.state.cards[index].btnHrefSecondary}
                      onChange={this.onChangeCardSimple}
                      disabled={!this.state.cards[index].hasBntSecondary}
                      className={classNames({
                        'p-invalid': isFormFieldValid(`${index}-btnHrefSecondary`),
                      })}
                    />
                  </span>
                  {getFormErrorMessage(`${index}-btnHrefSecondary`)}
                </div>
              </div>
              <div className="p-col-12 p-md-6 p-lg-6">
                <label className="p-text-bold">{t('Abrir en')}</label>
                <div className="p-field-radiobutton p-mt-2">
                  <RadioButton
                    inputId={`btnTargetSecondary${index}`}
                    name={`${index}-btnTargetSecondary`}
                    value="_blank"
                    onChange={this.onChangeCardSimple}
                    checked={this.state.cards[index].btnTargetSecondary === '_blank'}
                    disabled={!this.state.cards[index].hasBntSecondary}
                  />
                  <label className="p-pr-3" htmlFor={`btnTargetSecondary${index}`}>{t('Nueva ventana')}</label>
                  <RadioButton
                    inputId={`btnTargetSecondary${index}`}
                    name={`${index}-btnTargetSecondary`}
                    value="_self"
                    onChange={this.onChangeCardSimple}
                    checked={this.state.cards[index].btnTargetSecondary === '_self'}
                    disabled={!this.state.cards[index].hasBntSecondary}
                  />
                  <label htmlFor={`btnTargetSecondary${index}`}>{t('Ventana actual')}</label>
                </div>
                {/* <div className="p-field-radiobutton">
                </div> */}
              </div>
              <Divider align="left" type="dashed">
                <b>{t('Imagen')}</b>
              </Divider>
              <div className="p-col-12 p-md-6 p-lg-6">
                <FileInput
                  onChangeFile={(files, isImage) => this.uploadFileCard(files, isImage, index)}
                  files={this.state.cards[index].backgroundImg}
                  removeAllFiles={() => this.removeFileCard(index)}
                  removeFile={() => this.removeFileCard(index)}
                  accept="/image*"
                  txtDrop={t('Arrastra y suelta el archivo')}
                  classNameBorderMain={classNames({
                    'p-invalid': isFormFieldValid(`${index}-backgroundImg`),
                  })}
                />
                {getFormErrorMessage(`${index}-backgroundImg`)}
              </div>
            </div>
          </Panel>
        </div>
      ));
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-text-right p-d-flex p-jc-end">
              <Button
                label={t("Agregar servicio")}
                type="button"
                className="p-button-info"
                onClick={() => this.addService()}
                style={{width: '150px'}}
              />
            </div>
            {renderCards()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-primary"
                model={languagePreview}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
        <div>
          { showModalPreview.visible && (
            <ModalPreview
              language={showModalPreview.language}
              onHide={this.onHideModalPreview}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _carousel: state.section.carousel,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(CarouselForm);
